import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _a064878c = () => interopDefault(import('../pages/auth/index.vue' /* webpackChunkName: "pages/auth/index" */))
const _56ee6ac8 = () => interopDefault(import('../pages/cabinet/index.vue' /* webpackChunkName: "pages/cabinet/index" */))
const _b45ce736 = () => interopDefault(import('../pages/contracts/index.vue' /* webpackChunkName: "pages/contracts/index" */))
const _e5a135d6 = () => interopDefault(import('../pages/default_index.vue' /* webpackChunkName: "pages/default_index" */))
const _6ebd2d2e = () => interopDefault(import('../pages/general.vue' /* webpackChunkName: "pages/general" */))
const _258a8a5b = () => interopDefault(import('../pages/inspire.vue' /* webpackChunkName: "pages/inspire" */))
const _52f0c859 = () => interopDefault(import('../pages/need-help.vue' /* webpackChunkName: "pages/need-help" */))
const _c252bcac = () => interopDefault(import('../pages/profile.vue' /* webpackChunkName: "pages/profile" */))
const _1cf21b8a = () => interopDefault(import('../pages/residence/index.vue' /* webpackChunkName: "pages/residence/index" */))
const _17712991 = () => interopDefault(import('../pages/test-thankyou.vue' /* webpackChunkName: "pages/test-thankyou" */))
const _4e57a2f8 = () => interopDefault(import('../pages/auth/adfs.vue' /* webpackChunkName: "pages/auth/adfs" */))
const _3cbdffc8 = () => interopDefault(import('../pages/auth/fill-data.vue' /* webpackChunkName: "pages/auth/fill-data" */))
const _34871e04 = () => interopDefault(import('../pages/auth/resetpw.vue' /* webpackChunkName: "pages/auth/resetpw" */))
const _53d84aeb = () => interopDefault(import('../pages/cabinet/contracts.vue' /* webpackChunkName: "pages/cabinet/contracts" */))
const _c98c2c9c = () => interopDefault(import('../pages/cabinet/notifications.vue' /* webpackChunkName: "pages/cabinet/notifications" */))
const _ba328cfe = () => interopDefault(import('../pages/cabinet/recognition.vue' /* webpackChunkName: "pages/cabinet/recognition" */))
const _7178d2f6 = () => interopDefault(import('../pages/cabinet/startContracts.vue' /* webpackChunkName: "pages/cabinet/startContracts" */))
const _4a8767b6 = () => interopDefault(import('../pages/cabinet/svo.vue' /* webpackChunkName: "pages/cabinet/svo" */))
const _81429f2a = () => interopDefault(import('../pages/cabinet/tests.vue' /* webpackChunkName: "pages/cabinet/tests" */))
const _1f318e1a = () => interopDefault(import('../pages/contracts/new.vue' /* webpackChunkName: "pages/contracts/new" */))
const _4aa8e6a3 = () => interopDefault(import('../pages/contracts/successfullyCanceledApplication.vue' /* webpackChunkName: "pages/contracts/successfullyCanceledApplication" */))
const _5701b0cc = () => interopDefault(import('../pages/contracts/successfullyCreatedApplication.vue' /* webpackChunkName: "pages/contracts/successfullyCreatedApplication" */))
const _42cc63da = () => interopDefault(import('../pages/contracts/successfullyEditedApplication.vue' /* webpackChunkName: "pages/contracts/successfullyEditedApplication" */))
const _456eea93 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'is-active',
  scrollBehavior,

  routes: [{
    path: "/auth",
    component: _a064878c,
    name: "auth"
  }, {
    path: "/cabinet",
    component: _56ee6ac8,
    name: "cabinet"
  }, {
    path: "/contracts",
    component: _b45ce736,
    name: "contracts"
  }, {
    path: "/default_index",
    component: _e5a135d6,
    name: "default_index"
  }, {
    path: "/general",
    component: _6ebd2d2e,
    name: "general"
  }, {
    path: "/inspire",
    component: _258a8a5b,
    name: "inspire"
  }, {
    path: "/need-help",
    component: _52f0c859,
    name: "need-help"
  }, {
    path: "/profile",
    component: _c252bcac,
    name: "profile"
  }, {
    path: "/residence",
    component: _1cf21b8a,
    name: "residence"
  }, {
    path: "/test-thankyou",
    component: _17712991,
    name: "test-thankyou"
  }, {
    path: "/auth/adfs",
    component: _4e57a2f8,
    name: "auth-adfs"
  }, {
    path: "/auth/fill-data",
    component: _3cbdffc8,
    name: "auth-fill-data"
  }, {
    path: "/auth/resetpw",
    component: _34871e04,
    name: "auth-resetpw"
  }, {
    path: "/cabinet/contracts",
    component: _53d84aeb,
    name: "cabinet-contracts"
  }, {
    path: "/cabinet/notifications",
    component: _c98c2c9c,
    name: "cabinet-notifications"
  }, {
    path: "/cabinet/recognition",
    component: _ba328cfe,
    name: "cabinet-recognition"
  }, {
    path: "/cabinet/startContracts",
    component: _7178d2f6,
    name: "cabinet-startContracts"
  }, {
    path: "/cabinet/svo",
    component: _4a8767b6,
    name: "cabinet-svo"
  }, {
    path: "/cabinet/tests",
    component: _81429f2a,
    name: "cabinet-tests"
  }, {
    path: "/contracts/new",
    component: _1f318e1a,
    name: "contracts-new"
  }, {
    path: "/contracts/successfullyCanceledApplication",
    component: _4aa8e6a3,
    name: "contracts-successfullyCanceledApplication"
  }, {
    path: "/contracts/successfullyCreatedApplication",
    component: _5701b0cc,
    name: "contracts-successfullyCreatedApplication"
  }, {
    path: "/contracts/successfullyEditedApplication",
    component: _42cc63da,
    name: "contracts-successfullyEditedApplication"
  }, {
    path: "/",
    component: _456eea93,
    name: "index"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
